import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FileQuestion, ArrowLeft, Info, HelpCircle } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-amber-50/50 to-white p-4">
      <div className="max-w-4xl w-full space-y-8">
        {/* 404 Section */}
        <div className="text-center space-y-6">
          <div className="flex justify-center">
            <div className="bg-amber-100 p-3 rounded-full">
              <FileQuestion className="w-12 h-12 text-amber-600" />
            </div>
          </div>
          <div className="space-y-2">
            <h1 className="text-3xl font-bold tracking-tight">404 - Side ikke funnet</h1>
            <p className="text-muted-foreground max-w-md mx-auto">
              Beklager, men siden du leter etter eksisterer ikke eller har blitt flyttet.
            </p>
          </div>
        </div>

        <Separator className="my-8" />

        {/* Instructions and Guides Section */}
        <div className="grid gap-6 md:grid-cols-2">
          {/* System Instructions */}
          <Card>
            <CardHeader>
              <div className="flex items-center space-x-2">
                <Info className="w-5 h-5 text-amber-600" />
                <CardTitle>Systeminstruksjoner</CardTitle>
              </div>
              <CardDescription>Viktig informasjon om tjenesten</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <h3 className="font-medium">Kom i gang</h3>
                <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
                  <li>Logg inn med din brukerkonto</li>
                  <li>Opprett en ny sak fra dashbordet</li>
                  <li>Last opp relevante dokumenter</li>
                  <li>Bruk AI-assistenten for juridisk veiledning</li>
                </ul>
              </div>
              <div className="space-y-2">
                <h3 className="font-medium">Viktige funksjoner</h3>
                <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
                  <li>Dokumenthåndtering og analyse</li>
                  <li>Juridisk AI-assistent</li>
                  <li>Saksstyring og oppfølging</li>
                  <li>Sikker dokumentdeling</li>
                </ul>
              </div>
            </CardContent>
          </Card>

          {/* User Guide */}
          <Card>
            <CardHeader>
              <div className="flex items-center space-x-2">
                <HelpCircle className="w-5 h-5 text-amber-600" />
                <CardTitle>Brukerveiledning</CardTitle>
              </div>
              <CardDescription>Slik bruker du systemet</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <h3 className="font-medium">Daglig bruk</h3>
                <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
                  <li>Navigering i dashbordet</li>
                  <li>Håndtering av dokumenter</li>
                  <li>Bruk av AI-assistenten</li>
                  <li>Saksbehandling og oppfølging</li>
                </ul>
              </div>
              <div className="space-y-2">
                <h3 className="font-medium">Tips og triks</h3>
                <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
                  <li>Effektiv dokumentsøking</li>
                  <li>Tilpassing av innstillinger</li>
                  <li>Samarbeid med andre brukere</li>
                  <li>Sikkerhet og personvern</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Navigation Button */}
        <div className="flex justify-center mt-8">
          <Button asChild className="bg-amber-600 hover:bg-amber-700">
            <Link to="/" className="flex items-center space-x-2">
              <ArrowLeft className="w-4 h-4" />
              <span>Gå til forsiden</span>
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}